import {createDomElementHandler} from "@/scripts/utils/dom.utils";

import AB_FORM_NAMES from "@/scripts/components/ab-form/constants/abFormNames.constants";
import {REVIEW_FORM_FIELDS} from "@/scripts/components/review-form/constants/reviewForm.constants";
import {ProductResponseDTO, ProductReviewResponseDTO} from "@shared/DTO";
import {ProductTypeEnum} from "@shared/enums";
import {grammarFor} from "@shared/utils/grammar.utils";

const {
  CLASS_FORM,
  CLASS_FORM_CONTROL,
  CLASS_FORM_LABEL,
  CLASS_FORM_INPUT,
  CLASS_FORM_ERROR_MESSAGE,
  CLASS_FORM_SUBMIT,
  CLASS_FORM_FEEDBACK,
  CLASS_FORM_FEEDBACK__SUCCESS,
  CLASS_FORM_FEEDBACK__ERROR
} = AB_FORM_NAMES;

export function getIntro(
  product: ProductResponseDTO,
  reviews:  ProductReviewResponseDTO[]
) {
  if(!reviews?.length) {
    // In assenza di recensioni l'intro della lista (vuota) sovrastante funge da intro anche per il form
    return null;
  }
  const productName = product.productData.names?.at(0);
  const grammar = grammarFor(product);

  const heading = createDomElementHandler('h2', 'ab-user-review__intro');
  heading.textContent = `Aggiungi la tua opinione ${grammar.prep.su} ${product.productData.names?.at(0)}`;

  const paragraph = createDomElementHandler('p', 'ab-user-review__intro-text');

  paragraph.innerHTML = `Possiedi o hai avuto modo di provare ${grammar.demoThis} ${grammar.lemma}? `+
    `Condividi i tuoi commenti e le tue <strong>opinioni ${grammar.prep.su} ${productName}</strong> ` +
    `con gli altri utenti compilando il box qui sotto.`;

  return {heading, paragraph};
}

export function getForm(product: ProductResponseDTO) {

  const id = product?._id;
  const productName = product.productData?.names?.at(0);

  const formId = `post-review-form-${id}`;
  const form = createDomElementHandler("form", `${CLASS_FORM}`, {id: formId});
  const nameId = `${formId}-${REVIEW_FORM_FIELDS.NAME}`;
  const nameControl = createDomElementHandler('div', [CLASS_FORM_CONTROL, `${CLASS_FORM_CONTROL}--${REVIEW_FORM_FIELDS.NAME}`]);
  const nameLabel = createDomElementHandler('label', CLASS_FORM_LABEL, {for: nameId});
  nameLabel.textContent = 'Nome:';
  const nameInput = createDomElementHandler(
    'input',
    [CLASS_FORM_INPUT],
    {
      type: 'text',
      id: nameId,
      name: nameId,
      placeholder: 'Il tuo nome',
    }
  );

  const feedbackName = createDomElementHandler('div', CLASS_FORM_ERROR_MESSAGE);
  feedbackName.textContent = 'Inserisci il tuo nome o uno pseudonimo.';
  nameControl.append(nameLabel, nameInput, feedbackName);
  const emailId = `${formId}-${REVIEW_FORM_FIELDS.EMAIL}`;
  const emailControl = createDomElementHandler('div', [CLASS_FORM_CONTROL, `${CLASS_FORM_CONTROL}--${REVIEW_FORM_FIELDS.EMAIL}`]);
  const emailLabel = createDomElementHandler('label', CLASS_FORM_LABEL, {for: emailId});
  emailLabel.textContent = 'Email (non verrà pubblicata):';
  const emailInput = createDomElementHandler(
    'input',
    [CLASS_FORM_INPUT],
    {
      type: 'email',
      id: emailId,
      name: emailId,
      placeholder: 'La tua email',
    }
  );
  const emailFeedback = createDomElementHandler('div', CLASS_FORM_ERROR_MESSAGE);
  emailFeedback.textContent = 'Inserisci il tuo indirizzo email; non sarà pubblicato.';
  emailControl.append(emailLabel, emailInput, emailFeedback);

  const contentId = `${formId}-${REVIEW_FORM_FIELDS.CONTENT}`;
  const contentControl = createDomElementHandler('div', [CLASS_FORM_CONTROL, `${CLASS_FORM_CONTROL}--${REVIEW_FORM_FIELDS.CONTENT}`]);
  const labelContent = createDomElementHandler('label', CLASS_FORM_LABEL, {for: contentId});

  labelContent.textContent = `La tua recensione ${grammarFor(product).prep.di} ${productName}:`;

  const contentInput = createDomElementHandler(
    'textarea',
    [CLASS_FORM_INPUT],
    {
      id: contentId,
      name: contentId,
      rows: '4',
      placeholder: 'Descrivi cosa ti è piaciuto e cosa no',
    }
  );
  const contentFeedback = createDomElementHandler('div', CLASS_FORM_ERROR_MESSAGE);
  contentFeedback.textContent = 'Descrivi la tua opinione con un commento di almeno 40 caratteri.';
  contentControl.append(labelContent, contentInput, contentFeedback);

  const ratingId = `${formId}-${REVIEW_FORM_FIELDS.RATING}`;
  const ratingControl = createDomElementHandler('div', [CLASS_FORM_CONTROL, `${CLASS_FORM_CONTROL}--${REVIEW_FORM_FIELDS.RATING}`]);
  const labelRating = createDomElementHandler('label', CLASS_FORM_LABEL, {for: ratingId});
  labelRating.textContent = 'Il tuo voto:';
  const inputRating = createDomElementHandler(
    'ab-stars',
    [CLASS_FORM_INPUT],
    {
      rating: '0',
      selectable: 'true',
      name: ratingId,
      id: ratingId,
      size: 'lg',
    }
  );
  inputRating.style.display = 'block';
  const ratingFeedback = createDomElementHandler('div', CLASS_FORM_ERROR_MESSAGE);
  ratingFeedback.textContent = 'Indica il tuo voto.';
  ratingControl.append(labelRating, inputRating, ratingFeedback);

  const submitEl = createDomElementHandler('div');
  const submitButton = createDomElementHandler(
    'button',
    [`${CLASS_FORM_SUBMIT}`, "ab-btn"],
    {type: 'submit'}
  );
  submitButton.textContent = 'Invia Recensione';
  submitEl.append(submitButton);

  const feedbackSuccess = createDomElementHandler('p', [CLASS_FORM_FEEDBACK, CLASS_FORM_FEEDBACK__SUCCESS]);

  const feedbackError = createDomElementHandler('p', [CLASS_FORM_FEEDBACK, CLASS_FORM_FEEDBACK__ERROR]);

  form.append(ratingControl, contentControl, nameControl, emailControl, submitEl, feedbackSuccess, feedbackError);

  return form;

}